/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { FiscalBrandFillSegmented } from '../../../components/FiscalBrandFillSegmented';
import type { ArcaEnvironment } from '../../../domain/fiscalTypes';
import { spacing } from '../../../../shared/theme/spacing';
import { typography } from '../../../../shared/theme/typography';
import { ticketColors } from '../../../../shared/theme/ticketColors';

const OPTIONS = [
  {
    value: 'produccion' as const,
    label: 'Facturar de verdad',
    subtitle: 'Los comprobantes valen.',
  },
  {
    value: 'homologacion' as const,
    label: 'Probar',
    subtitle: 'Sin validez legal.',
  },
];

export type ArcaSetupIntentStepProps = {
  value: ArcaEnvironment;
  onChange: (value: ArcaEnvironment) => void;
  disabled?: boolean;
};

export function ArcaSetupIntentStep({ value, onChange, disabled = false }: ArcaSetupIntentStepProps) {
  return (
    <View style={styles.card}>
      <Text style={styles.title}>¿Vas a facturar de verdad?</Text>
      <FiscalBrandFillSegmented
        options={OPTIONS}
        value={value}
        onChange={onChange}
        disabled={disabled}
        vertical
        accessibilityLabel="Para qué facturás"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: ticketColors.paper,
    borderRadius: 14,
    padding: spacing.lg,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    gap: spacing.md,
  },
  title: { ...typography.titleLg, color: ticketColors.ink },
});
